export const paymentsData = [
  {
    key: "1",
    TRANSACTIONID: "TX12345",
    NAME: "Andrew Simons",
    IMAGE: "avatar-20.jpg",
    AMOUNT: "$120.00",
    PAYMENTMETHOD: "Credit Card",
    DATE: "24 Jan 2025",
    STATUS: "Completed",
  },
  {
    key: "2",
    TRANSACTIONID: "TX12346",
    NAME: "David Steiger",
    IMAGE: "avatar-21.jpg",
    AMOUNT: "$85.00",
    PAYMENTMETHOD: "Debit Card",
    DATE: "19 Dec 2024",
    STATUS: "Pending",
  },
  {
    key: "3",
    TRANSACTIONID: "TX12347",
    NAME: "Virginia Phu",
    IMAGE: "avatar-12.jpg",
    AMOUNT: "$250.00",
    PAYMENTMETHOD: "PayPal",
    DATE: "11 Dec 2024",
    STATUS: "Completed",
  },
  {
    key: "4",
    TRANSACTIONID: "TX12348",
    NAME: "Walter Hartmann",
    IMAGE: "avatar-22.jpg",
    AMOUNT: "$175.00",
    PAYMENTMETHOD: "Bank Transfer",
    DATE: "29 Nov 2024",
    STATUS: "Refunded",
  },
  {
    key: "5",
    TRANSACTIONID: "TX12349",
    NAME: "Andrea Jermaine",
    IMAGE: "avatar-27.jpg",
    AMOUNT: "$200.00",
    PAYMENTMETHOD: "Digital Payment",
    DATE: "03 Nov 2024",
    STATUS: "Completed",
  },
  {
    key: "6",
    TRANSACTIONID: "TX12350",
    NAME: "Dennis Eckhardt",
    IMAGE: "avatar-05.jpg",
    AMOUNT: "$90.00",
    PAYMENTMETHOD: "Credit Card",
    DATE: "31 Oct 2024",
    STATUS: "Pending",
  },
  {
    key: "7",
    TRANSACTIONID: "TX12351",
    NAME: "Lan Adams",
    IMAGE: "avatar-25.jpg",
    AMOUNT: "$160.00",
    PAYMENTMETHOD: "Debit Card",
    DATE: "15 Oct 2024",
    STATUS: "Completed",
  },
  {
    key: "8",
    TRANSACTIONID: "TX12352",
    NAME: "Ann Crump",
    IMAGE: "avatar-28.jpg",
    AMOUNT: "$180.00",
    PAYMENTMETHOD: "PayPal",
    DATE: "26 Sep 2024",
    STATUS: "Failed",
  },
  {
    key: "9",
    TRANSACTIONID: "TX12353",
    NAME: "Julie Black",
    IMAGE: "avatar-07.jpg",
    AMOUNT: "$230.00",
    PAYMENTMETHOD: "Bank Transfer",
    DATE: "01 Sep 2024",
    STATUS: "Completed",
  },
  {
    key: "10",
    TRANSACTIONID: "TX12354",
    NAME: "Jean Walker",
    IMAGE: "avatar-29.jpg",
    AMOUNT: "$300.00",
    PAYMENTMETHOD: "Digital Payment",
    DATE: "15 Aug 2024",
    STATUS: "Completed",
  },
];
